import CheckoutFreeItem from '@theme/components/cart/CheckoutFreeItem'

export default {
  components: { CheckoutFreeItem },
}
